import { FC } from 'react';

import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from 'modules/_shared/components/LayoutV9/block/Block';
import Head from 'modules/_shared/components/LayoutV9/head/Head';
import Page from 'modules/_shared/components/Pages/Page';
import Content from 'modules/_shared/components/LayoutV9/content/Content';
import { PreviewCard } from 'modules/_shared/components/LayoutV9/preview/Preview';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';

const Privacy: FC = () => (
  <Page className="bg-lighter pb-5">
    <Head title="Política de Privacidad" />
    <Content>
      <div className="content-page wide-md m-auto">
        <BlockHead size="lg" wide="xs" className="mx-auto">
          <BlockHeadContent className="text-center">
            {/* @ts-ignore */}
            <BlockTitle tag="h2" className="fw-normal">
              Política de Privacidad
            </BlockTitle>
            {/* @ts-ignore */}
            <BlockDes>
              <p className="lead">Área Privada accionistas</p>
              <p className="text-soft ff-italic">Fecha de publicación: 2026</p>

              <GoBackButton hideWhenNoHistory />
            </BlockDes>
          </BlockHeadContent>
        </BlockHead>
        {/* @ts-ignore */}
        <Block>
          {/* @ts-ignore */}
          <PreviewCard className="card-inner">
            <div className="entry">
              <h3 className="mb-3">
                ¿Quién es el responsable del tratamiento de sus datos?
              </h3>
              <p>
                El responsable del tratamiento de los datos personales del
                Usuario será la siguiente Entidad Aseguradora:
              </p>
              <ul className="list mb-4">
                <li>
                  AXA SEGUROS GENERALES S.A. DE SEGUROS Y REASEGUROS, con CIF:
                  A60917978 y domicilio social en Calle Monseñor Palmer nº1.
                  07014, Palma de Mallorca (España) e inscrita en el Registro
                  Mercantil de Palma de Mallorca, Tomo 2325, Folio 97, Hoja
                  PM-61041
                </li>
              </ul>
              <p>En adelante, denominada como AXA.</p>

              <h3 className="mb-3">
                ¿Por qué y para qué tratamos sus datos personales?
              </h3>
              <p>
                A continuación, se detallan las principales finalidades de
                tratamiento de los datos de carácter personal facilitados por
                los Usuarios a través del Área Privada del accionista de AXA:
              </p>
              <ul className="list mb-4">
                <li>Mantenimiento del sitio web.</li>
                <li>
                  Igualmente, el Usuario podrá facilitar a AXA, a través del
                  Área Privada del accionista, determinada documentación con
                  información y datos personales, necesarios para la gestión de
                  la relación accionarial.
                </li>
                <li>
                  En el supuesto de que el Usuario solicite, a través de
                  cualquiera de los canales de comunicación habituales de AXA
                  (correo postal, telefónico, correo electrónico), cualquier
                  tipo de información o para cualquier gestión relacionada con
                  las acciones de su titularidad, AXA tratará sus datos con la
                  finalidad de poder atender correctamente dicha solicitud.
                </li>
              </ul>

              <h3 className="mb-3">
                ¿Qué categorías de datos personales se tratan?
              </h3>
              <ul className="list mb-4">
                <li>Datos identificativos y de contacto.</li>
                <li>Datos de características personales.</li>
                <li>Datos de cuenta bancaria.</li>
                <li>Datos fiscales.</li>
                <li>
                  Datos de discapacidad, en cuanto se aporten por ejemplo
                  poderes de representación.
                </li>
                <li>
                  Información y datos personales contenidos en documentos
                  necesarios para efectuar las transacciones por el accionista
                  titular de las acciones con impacto en la ejecución de la
                  relación accionarial.
                </li>
              </ul>

              <h3 className="mb-3">
                ¿Qué legitimidad tiene el responsable del tratamiento para el
                tratamiento de sus datos personales?
              </h3>
              <p>
                Las bases legales que legitiman a AXA GRUPACIÓ para el
                tratamiento de sus datos personales son las que seguidamente se
                detallan:
              </p>
              <p>
                <strong>Ejecución de la relación accionarial:</strong> aplica
                cuando existe una relación accionarial con los Usuarios
                accionistas de AXA y el tratamiento de sus datos es necesario
                para cualquier gestión relacionada con acciones de su
                titularidad, como sucede, por ejemplo, en los procesos de
                compraventa de acciones.
              </p>
              <p>
                Para el mantenimiento del sitio web, la base de legitimación es
                el interés legítimo para permitir la comunicación entre el
                equipo del Usuario y la red, para prestar el servicio solicitado
                en el Sitio Web como el log-in del Usuario y su identificación
                posterior.
              </p>

              <h3 className="mb-3">
                ¿Durante cuánto tiempo conservamos sus datos?
              </h3>
              <p>
                Los datos de Usuarios accionistas de AXA serán conservados
                durante la vigencia de su relación accionarial con dicha entidad
                y, al vencimiento de la misma, los mantendrá bloqueados durante
                los plazos de prescripción de las obligaciones legales, conforme
                a la normativa vigente en cada momento.
              </p>

              <h3 className="mb-3">
                ¿Quiénes son los principales destinatarios de sus datos
                personales?
              </h3>
              <p>
                Los datos facilitados por el Usuario podrán ser comunicados o
                podrán ser objeto de acceso por parte de:
              </p>
              <p>
                En caso de que usted solicite la venta de sus acciones, los
                siguientes destinatarios podrán acceder a sus datos:
              </p>
              <ul className="list mb-4">
                <li>
                  el o los accionistas compradores de sus acciones; empresas del
                  Grupo AXA en España (al cual pertenece AXA) con fines de
                  gestión administrativa, en calidad de encargados del
                  tratamiento;
                </li>
                <li>
                  terceras empresas proveedoras de servicios que actúan como
                  encargados de tratamiento de AXA,
                </li>
                <li>
                  organismos públicos y autoridades competentes que, por
                  imperativo legal, estén legitimadas para acceder a sus datos.
                </li>
              </ul>

              <h3 className="mb-3">
                ¿Existen transferencias internacionales de datos personales?
              </h3>
              <p>
                Le informamos de que AXA tiene aprobadas unas Normas
                Corporativas Vinculantes, se trata de un estándar reconocido
                internacionalmente que proporciona una adecuada protección en la
                gestión de los datos de carácter personal en el ámbito de una
                compañía multinacional. Estas normas han sido aprobadas por 16
                autoridades de protección de datos europeas, entre ellas la
                Agencia Española de Protección de Datos. De una forma más
                concreta, en dichas normas se establecen unas medidas similares
                para la protección de datos personales obtenidos en el curso del
                negocio cuando dichos datos deban transferirse dentro de las
                compañías del Grupo. Asimismo, en AXA se han adoptado unos
                compromisos en materia de protección de datos.
              </p>
              <p>
                Sus datos personales podrán ser comunicados a destinatarios
                ubicados en países fuera del Espacio Económico Europeo,
                incluyendo países que no proporcionan un nivel de protección de
                datos equivalente al de la Unión. Sin embargo, en estos casos,
                los mismos serán tratados con escrupuloso cumplimiento de la
                legislación europea y española y, asimismo, se implementarán las
                garantías que le indicamos a continuación:
              </p>
              <ul className="list mb-4">
                <li>
                  Categoría de destinatario: Entidades del Grupo AXA por
                  ejemplo, AXA Business Services Pvt. Ltd. País: India;
                  Garantía: Normas Corporativas Vinculantes. Puede consultarlas{' '}
                  <a href="https://www.axa.com/en/commitments/our-commitments">
                    aquí
                  </a>
                  : https://www.axa.com/en/commitments/our-commitments
                </li>
                <li>
                  Categoría de destinatario: Prestadores de servicios
                  tecnológicos y de marketing País: EEUU; Garantía: Cláusulas
                  Contractuales Tipo, adoptadas por la Comisión Europea el 4 de
                  junio de 2021 (Texto pertinente a efectos del EEE)
                  (2021/914/UE). Puede consultarlas{' '}
                  <a href="https://www.boe.es/buscar/doc.php?id=DOUE-L-2021-80739">
                    aquí
                  </a>
                  : https://www.boe.es/buscar/doc.php?id=DOUE-L-2021-80739
                </li>
              </ul>

              <h3 className="mb-3">
                ¿Cuáles son sus derechos cuando nos facilita sus datos
                personales?
              </h3>
              <p>
                La normativa vigente te permite ejercer los derechos que se
                detallan a continuación para la protección de tus datos
                personales respecto de los tratamientos informados:
              </p>
              <ul className="list list-sm list-checked mb-4">
                <li>
                  <strong>Derecho de acceso</strong>: permite al Interesado
                  dirigirse al responsable del tratamiento para conocer si está
                  tratando o no sus datos personales y, en el caso de que se
                  esté realizando dicho tratamiento, obtener cierta información
                  al respecto (fines del tratamiento, categorías de datos
                  tratadas, origen de los datos, plazo previsto de
                  conservación).
                </li>
                <li>
                  <strong>Derecho de rectificación</strong>: permite al
                  Interesado solicitar al responsable del tratamiento la
                  modificación de sus datos personales cuando los mismos sean
                  inexactos o no respondan a la situación real del interesado y
                  a completar dichos datos personales cuando sean incompletos.
                </li>
                <li>
                  <strong>Derecho de oposición</strong>: permite al Interesado
                  oponerse a que el responsable realice un tratamiento de los
                  datos personales cuando: (i) esté basado en el interés
                  legítimo del responsable o (ii) tenga como finalidad la
                  mercadotecnia directa, incluyendo en ambos casos la
                  elaboración de perfiles.
                </li>
                <li>
                  <strong>Derecho de supresión</strong>: permite al Interesado
                  solicitar al responsable la supresión de sus datos personales
                  cuando concurren determinadas circunstancias, por lo que no se
                  puede considerar un derecho ilimitado.
                </li>
                <li>
                  <strong>Derecho de portabilidad</strong>: permite al
                  Interesado disponer de un mayor control sobre sus datos
                  personales, de forma que cuando el tratamiento se efectúe por
                  medios automatizados y se legitime en base al consentimiento o
                  en el marco de la ejecución de un contrato, pueda solicitar al
                  responsable la recepción de sus datos personales en un formato
                  estructurado, de uso común, de lectura mecánica e
                  interoperable o su transmisión segura a otro responsable del
                  tratamiento.
                </li>
              </ul>

              <h3 className="mb-3">
                ¿Ante quién puede ejercitar sus reclamaciones?
              </h3>
              <p>
                Para el ejercicio de cualquiera de estos derechos, el Usuario
                tiene que remitir una comunicación escrita con la referencia
                &quot;Protección de Datos&quot;, identificándose fehacientemente
                y concretando la solicitud que realiza. Para el envío de la
                comunicación con la solicitud de ejercicio de estos derechos, la
                Entidad Aseguradora pone a disposición del usuario los
                siguientes canales de comunicación:
              </p>
              <ul className="list mb-4">
                <li>
                  Como titular de los datos, y en cualquier momento, usted tiene
                  derecho a dirigirse a AXA, Ejercicio derechos de privacidad –
                  Atención Accionista, calle Emilio Vargas, 6, 28043, Madrid o a
                  la dirección de email{' '}
                  <a href="mailto:buzon.legal.corporativo@axa.es">
                    buzon.legal.corporativo@axa.es
                  </a>
                </li>
                <li>
                  Para cualquier duda o cuestión adicional sobre el ejercicio de
                  sus derechos o, en general, sobre el tratamiento de sus datos
                  personales, puede contactar con nuestro Delegado de Protección
                  de datos en <a href="mailto:DPOAXA@axa.es">DPOAXA@axa.es</a>
                </li>
              </ul>
              <p>
                Por último, informamos a los Usuarios que les asiste el derecho
                a presentar cualquier reclamación ante la Autoridad de Control
                (Agencia Española de Protección de Datos: C/ Jorge Juan, 6.
                28001 --Madrid <a href="https://www.aepd.es/">www.aepd.es</a>)
                en relación con el tratamiento de sus datos personales o el
                correcto ejercicio de los derechos reconocidos por la normativa
                vigente.
              </p>

              <h3 className="mb-3">Información de terceros</h3>
              <p>
                En caso de que el Usuario facilite información relativa a
                terceros en base a la relación accionarial, deberá haber
                informado previamente a esas personas sobre los términos y
                condiciones recogidos en esta Política de Privacidad y, en su
                caso, incluso haber obtenido su consentimiento acerca de este
                hecho, informándole sobre la finalidad a que se destinarán sus
                datos y la forma de ejercer sus derechos legales.
              </p>
            </div>
          </PreviewCard>
        </Block>

        {/* @ts-ignore */}
        <Block className="d-flex justify-content-center">
          <GoBackButton hideWhenNoHistory />
        </Block>
      </div>
    </Content>
  </Page>
);

export default Privacy;
